const errorDiv = `<div id="partoo-error" class="partoo-error-container" style="visibility: visible; display: none;">
    <div class="partoo-error" />
      <div class="partoo-error-icon">❌</div>
      <div>There was an unexpected error</div> 
    </div>
</div>`;

export default errorDiv;
